import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import {
  createSchemeDetail,
  updateSchemeDetail,
  deleteSchemeDetail,
  fetchSchemeDetailsBySchemeId,
  fetchAllSchemesWithDetails,
} from "services/schemedetail";

export const useCreateSchemeDetail = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data) => createSchemeDetail(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["schemesWithDetails"] });
      queryClient.invalidateQueries({ queryKey: ["schemeDetails"] });
    },
  });
};

export const useUpdateSchemeDetail = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ id, data }) => updateSchemeDetail(id, data),
    onSuccess: (data, variables) => {
      queryClient.invalidateQueries({ queryKey: ["schemesWithDetails"] });
      queryClient.invalidateQueries({ queryKey: ["schemeDetails", variables.id] });
    },
  });
};

export const useDeleteSchemeDetail = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (id) => deleteSchemeDetail(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["schemesWithDetails"] });
      queryClient.invalidateQueries({ queryKey: ["schemeDetails"] });
    },
  });
};

export const useSchemeDetailsBySchemeId = (id, enabled = true) => {
  return useQuery({
    queryKey: ["schemeDetails", id],
    queryFn: () => fetchSchemeDetailsBySchemeId(id),
    enabled: !!id && enabled,
    staleTime: 1000 * 60 * 5, // 5 minutes
  });
};

export const useAllSchemesWithDetails = (filters = {}, enabled = true) => {
  return useQuery({
    queryKey: ["schemesWithDetails", filters],
    queryFn: () => fetchAllSchemesWithDetails(filters),
    enabled,
    staleTime: 1000 * 60 * 5, // 5 minutes
  });
};
